import React, { useState, useContext } from "react";
import AddStudents from '../components/Students/AddStudents';
import AuthContext from "../AuthContext";
import AllStudents from '../components/Students/AllStudents';
import UpdateStudent from '../components/Students/UpdateStudent';
import Attendance from '../components/Students/Attendance';
import Placement from '../components/Students/Placement';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showPlacementModal, setShowPlacementModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [placement, setPlacement] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const authContext = useContext(AuthContext);

  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  const updateAttendanceSetting = (selectedProductData) => {
    setAttendance(selectedProductData);
    setShowAttendanceModal(!showAttendanceModal);
  };

  const updatePlacementSetting = (selectedProductData) => {
    setPlacement(selectedProductData);
    setShowPlacementModal(!showPlacementModal);
  };

  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add Student Modal */}
        {showProductModal && (
          <AddStudents
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Update Student Modal */}
        {showUpdateModal && (
          <UpdateStudent
            updateProductData={updateProduct}
            handlePageUpdate={handlePageUpdate}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Attendance Modal */}
        {showAttendanceModal && (
          <Attendance
            updateAttendanceData={attendance}
            handlePageUpdate={handlePageUpdate}
            updateAttendanceSetting={updateAttendanceSetting}
          />
        )}

        {/* Placement Modal */}
        {showPlacementModal && (
          <Placement
            handlePageUpdate={handlePageUpdate}
            updatePlacementData={placement}
            updateModalSetting={updatePlacementSetting}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Students</h2>
            <div className="flex gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
                onClick={addProductModalSetting}
              >
                Add New Student
              </button>
            </div>
          </div>
          <AllStudents 
            updateProductModalSetting={updateProductModalSetting}
            updateAttendanceSetting={updateAttendanceSetting}
            updatePlacementSetting={updatePlacementSetting}
            handlePageUpdate={handlePageUpdate}
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
